import { getCompanyB2BOrganizationId } from '@/types';

import type { B2BProvisioningStatus, Company } from '@/types';

type ProvisioningSeverity = 'error' | 'info' | 'success' | 'warning';

interface CompanyProvisioningPresentation {
  rolloutGuidance: string | null;
  settingsAction: string;
  severity: ProvisioningSeverity;
}

export const COMPANY_PROVISIONING_PRESENTATION: Record<
  B2BProvisioningStatus,
  CompanyProvisioningPresentation
> = {
  conflict: {
    rolloutGuidance:
      'Review the company domains or contact Engineering before enabling B2B rollout.',
    settingsAction:
      'Review the domains or contact Engineering before retrying.',
    severity: 'error',
  },
  linked: {
    rolloutGuidance: null,
    settingsAction: 'Domain changes will synchronize this organization.',
    severity: 'success',
  },
  manual_action: {
    rolloutGuidance: 'Contact Engineering before enabling B2B rollout.',
    settingsAction: 'Contact Engineering before making another change.',
    severity: 'error',
  },
  pending: {
    rolloutGuidance:
      'Wait for provisioning to finish before enabling B2B rollout.',
    settingsAction:
      'Wait for provisioning to finish, then refresh the company.',
    severity: 'info',
  },
  unlinked: {
    rolloutGuidance:
      "This member's company needs to be linked to a B2B organization first.",
    settingsAction:
      'Add or update domains and save to provision automatically.',
    severity: 'warning',
  },
};

export const getCompanyProvisioningStatus = (
  company?: Partial<Company> | null,
): B2BProvisioningStatus => {
  const runtimeStatus = company?.b2bProvisioningStatus as string | undefined;
  if (
    runtimeStatus &&
    Object.hasOwn(COMPANY_PROVISIONING_PRESENTATION, runtimeStatus)
  ) {
    return runtimeStatus as B2BProvisioningStatus;
  }
  if (runtimeStatus) return 'manual_action';

  return getCompanyB2BOrganizationId(company) ? 'linked' : 'unlinked';
};
